import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';
import type { LoadableComponent } from '@townsquare/loadable/types';
import { RouteContext } from '@townsquare/router/routing-types';

export const FollowProjectAction: ComponentType<RouteContext> & LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: "FollowProjectAction" */ './FollowProjectAction'),
	loading: () => null,
});
